export const KLARO_SERVICE_ANALYTIQUE = 'analytique';

export const KLARO_COOKIE_NAME = 'klaro';

export const KLARO_CONFIG = {
  version: 1,
  elementID: 'klaro',
  styling: { theme: ['light', 'bottom', 'wide'] },
  storageMethod: 'cookie',
  cookieName: KLARO_COOKIE_NAME,
  cookieExpiresAfterDays: 180,
  default: false,
  mustConsent: false,
  acceptAll: true,
  hideDeclineAll: false,
  hideLearnMore: true,
  htmlTexts: false,
  lang: 'fr',
  services: [
    {
      name: KLARO_SERVICE_ANALYTIQUE,
      title: 'Mesure d\'audience',
      purposes: ['analytics'],
      default: false,
      required: false,
      cookies: [],
    },
  ],
  translations: {
    fr: {
      consentModal: {
        title: 'Vos préférences de confidentialité',
        description:
          'Nous utilisons des services de mesure d\'audience pour améliorer e-parcours. '
          + 'Les données internes nécessaires au fonctionnement (préférences d\'affichage, colonnes, filtres) '
          + 'ne sont pas concernées par ce choix.',
      },
      consentNotice: {
        description:
          'Nous utilisons des services de mesure d\'audience pour améliorer e-parcours. '
          + 'Vos préférences d\'affichage ne sont pas concernées.',
      },
      ok: 'Tout accepter',
      acceptAll: 'Tout accepter',
      acceptSelected: 'Enregistrer',
      decline: 'Tout refuser',
      close: 'Fermer',
      save: 'Enregistrer',
      purposes: {
        analytics: {
          title: 'Mesure d\'audience',
          description: 'Statistiques anonymisées d\'utilisation de l\'application.',
        },
      },
      purposeItem: { service: 'service', services: 'services' },
      poweredBy: 'Propulsé par Klaro',
      service: {
        optOut: { title: '(désactivé par défaut)', description: '' },
        required: { title: '(toujours requis)', description: '' },
        purpose: 'Finalité',
        purposes: 'Finalités',
      },
      [KLARO_SERVICE_ANALYTIQUE]: {
        description: 'Statistiques anonymisées d\'utilisation de l\'application.',
      },
    },
  },
};
